
 <template>
    <div class="carousel-content">
      <div class="carousel">
        <div class="inner" ref="inner" :style="innerStyles">
          <div class="card" v-for="card in cards" :key="card">
            <!-- <show-image class="h-32 w-48" :imageName="attachment.file_1" /> -->
             <img class="h-32 w-48" :src="card">
          </div>
        </div>
      </div>
      <div class="carousel-control">
        <button class="prev" @click="prev">prev</button>
        <button class="next" @click="next">next</button>
      </div>
    </div>
  </template>

  <script>
  export default {
    data () {
      return {
        cards: [
          'https://news.mit.edu/sites/default/files/styles/news_article__image_gallery/public/images/202012/MIT-Coding-Brain-01-press_0.jpg',
          'https://carwow-uk-wp-3.imgix.net/18015-MC20BluInfinito-scaled-e1666008987698.jpg',
          'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f9/Money_Cash.jpg/1024px-Money_Cash.jpg',
          'https://rimage.gnst.jp/livejapan.com/public/article/detail/a/00/02/a0002533/img/basic/a0002533_main.jpg',
          'https://media.suara.com/pictures/970x544/2020/01/14/62937-ilustrasi-traveling.jpg',
          'https://www.justtravelous.com/wp-content/uploads/2012/06/sunrise-in-bocean-fort-lauderdale.jpg'
        ],
        innerStyles: {},
        step: '',
        transitioning: false
      }
    },
    mounted () {
      this.setStep()
      this.resetTranslate()
    },
    methods: {
      setStep () {
        const innerWidth = this.$refs.inner.scrollWidth
        const totalCards = this.cards.length
        this.step = `${innerWidth / totalCards}px`
      },
      next () {
        if (this.transitioning) return
        this.transitioning = true
        this.moveLeft()
        this.afterTransition(() => {
          const card = this.cards.shift()
          this.cards.push(card)
          this.resetTranslate()
          this.transitioning = false
        })
      },
      prev () {
        if (this.transitioning) return
        this.transitioning = true
        this.moveRight()
        this.afterTransition(() => {
          const card = this.cards.pop()
          this.cards.unshift(card)
          this.resetTranslate()
          this.transitioning = false
        })
      },
      moveLeft () {
        this.innerStyles = {
          transform: `translateX(-${this.step})
                      translateX(-${this.step})`
        }
      },
      moveRight () {
        this.innerStyles = {
          transform: `translateX(${this.step})
                      translateX(-${this.step})`
        }
      },
      afterTransition (callback) {
        const listener = () => {
          callback()
          this.$refs.inner.removeEventListener('transitionend', listener)
        }
        this.$refs.inner.addEventListener('transitionend', listener)
      },
      resetTranslate () {
        this.innerStyles = {
          transition: 'none',
          transform: `translateX(-${this.step})`
        }
      }
    }
  }
  </script>

  <style>
  .carousel-content{
    max-width: 100%;
    height: 130px;
  }
  .carousel {
    width: 100%;
    overflow: hidden;
    padding: 1px;
  }
  .inner {
    transition: transform 0.2s;
    white-space: nowrap;
  }
  .card {
    margin-right: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  /* optional */
  button {
    margin-right: 5px;
    margin-top: 10px;
    color: white;
  }
  .carousel-control {
    bottom: 95px;
      border: none;
      position: relative;
      color: #f3f3f3;
      /* cursor: pointer; */
      display: flex;
      justify-content: space-between;
      width: 100%;
  }
  .prev {
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    width: 50px;
    height: 50px;
  }
  .next {
    right: 0;
    background-color: rgba(0, 0, 0, 0.5);
    width: 50px;
    height: 50px;
  }
  </style>
